import * as React from 'react';

class SearchSvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg
        viewBox="0 0 24 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`svg-icon search-svg ${className || 'm-3'}`}
        {...rest}
      >
        <path
          d="M23.71 24.2903L18.12 18.7103C20.0064 16.7734 21.0745 14.1846 21.1029 11.481C21.1313 8.77748 20.1177 6.16679 18.2724 4.1907C16.4272 2.21461 13.8919 1.02483 11.1927 0.868256C8.49358 0.711679 5.83776 1.60032 3.77637 3.34979C1.71498 5.09926 0.4063 7.57523 0.121878 10.2639C-0.162544 12.9526 0.599135 15.6476 2.24886 17.7896C3.89859 19.9317 6.3097 21.3563 8.98188 21.768C11.6541 22.1796 14.3821 21.5466 16.6 20.0003L22.29 25.6803C22.3833 25.7729 22.4938 25.8462 22.6154 25.8961C22.737 25.9459 22.8672 25.9713 22.9985 25.9709C23.1299 25.9704 23.26 25.9441 23.3812 25.8934C23.5024 25.8426 23.6124 25.7686 23.705 25.6753C23.7976 25.5821 23.8709 25.4715 23.9208 25.3499C23.9706 25.2284 23.996 25.0982 23.9956 24.9668C23.9951 24.8354 23.9688 24.7054 23.9181 24.5842C23.8673 24.4629 23.7933 24.3529 23.7 24.2603L23.71 24.2903ZM16.51 17.5103C15.1191 18.9011 13.2888 19.7664 11.3313 19.9588C9.37378 20.1511 7.41012 19.6586 5.77506 18.5652C4.14 17.4719 2.93474 15.8452 2.36474 13.9627C1.79474 12.0801 1.89529 10.0581 2.64923 8.24142C3.40317 6.42469 4.76384 4.92567 6.49931 3.99988C8.23477 3.07408 10.2376 2.77883 12.1664 3.16444C14.0952 3.55005 15.8305 4.59266 17.0767 6.11454C18.3228 7.63642 19.0025 9.54336 19 11.5103C19.0002 12.6251 18.7804 13.7289 18.3531 14.7585C17.9258 15.7881 17.2995 16.7233 16.51 17.5103Z"
          fill="#EA1C0A"
        />
      </svg>
    );
  }
}

export default SearchSvg;
